var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6373A4",
    fillRule: "nonzero",
    d: "M20.896 2H3.104C2.494 2 2 2.494 2 3.104v17.793C2 21.506 2.494 22 3.104 22h9.58v-7.745h-2.607v-3.018h2.606V9.01c0-2.584 1.578-3.99 3.883-3.99 1.104 0 2.052.082 2.329.119v2.7h-1.598c-1.254 0-1.496.597-1.496 1.47v1.927h2.989l-.39 3.019h-2.6V22h5.098c.608 0 1.102-.494 1.102-1.104V3.104C22 2.494 21.506 2 20.896 2z"
  })));
}
export default SvgFacebook;